import Alpine from 'alpinejs';
import config from '@src/js/config';
Alpine.data('header', () => ({
    userDropDownActive: false,
    heygenQuota: 'N/A',
    ready: false,
    logout() {
        // Clear auth token cookie and redirect to login
        document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        window.location.href = config.APP_URL + "auth.html?state=login";
    },
    async init() {
        try {
            const res = await fetch(config.API_URL + 'chat/quota', {
                headers: {
                    'Accept': 'application/json'
                }
            });
            const json = await res.json();
            this.heygenQuota = json?.data?.remaining_quota ?? 'N/A';
            console.log("HeyGen quota fetched successfully:", this.heygenQuota);
            this.ready = true;
        }
        catch (err) {
            console.error('Failed to fetch HeyGen quota:', err);
            console.log(config);
            this.heygenQuota = 'N/A';
        }
    }
}));
